import { TSelectOptionType } from '@components/common/Select/Select.types';

export const selectAllOption: TSelectOptionType = { label: 'Select All', value: 'select-all' };
export const DELAY_FOR_TOOLTIP = 1500;
export const EMPTY_LABEL = '__EMPTY__:';
